import React from 'react';

import { Box } from '@clutter/clean';

import { Footer } from '@shared/content/footer';
import { Header } from '@shared/header/header';

export const Layout = ({ children }: { children: React.ReactNode }) => (
  <>
    <Header sticky opaque />
    <Box minHeight="100vh" margin="0 auto">
      {children}
    </Box>
    <Footer />
  </>
);
